import React from 'react'
import FormFactory from '../../../components/form/form-factory'

import {
  Container,
  Wrapper,
  Greetings,
  FormWrapper,
  FormContent,
  Footer,
  Support,
} from './styles'

import LogoSvg from '../../../assets/svg/logo.svg'
import IFormPage from '../../../interfaces/form-page'
import { If } from '../../../components/if/if'

type IProps = any & IFormPage

const Signin = ({
  dataForm,
  onSubmit,
  errorMessage,
}: IProps): JSX.Element => (
  <Container>
    <Wrapper>
      <Greetings>
        <h1>Bem-vindo(a)!</h1>
        <p>Faça o login para ter acesso ao seu painel administrativo</p>
      </Greetings>

      <FormWrapper action="">
        <FormContent>

          <h2>Login - Gestor</h2>

          <FormFactory
            data={dataForm}
            onSubmit={onSubmit}
            submitErrorMessage={errorMessage}
          />
        </FormContent>
        <If condition={errorMessage === 'Acesso negado, entre em contato com suporte:'}>
          <Support>
            <p>
              E-mail:
              {' '}
              <a href="mailto:contato@fingermenu.com"> contato@fingermenu.com</a>
            </p>
            <p>
              Whatsapp:
              {' '}
              <a
                href="https://api.whatsapp.com/send?phone=3132143544"
                target="_blank"
                rel="noreferrer"
              >
                (31) 3214-3544
              </a>
            </p>
          </Support>
        </If>
      </FormWrapper>
    </Wrapper>

    <Footer>
      <img src={LogoSvg} alt="FingerMenu logo" />
    </Footer>
  </Container>
)

export default Signin
